import React, {FC}                                   from 'react';
import {ELocales}                                    from '@sirius/ui-lib/src/subjects/Locale';
import {formatDateWOptions}                          from '@sirius/ui-lib/src/utils/date';
import {ColumnCellType, DataCellType, UiSchemaEntry} from '@sirius/ui-lib/src/blocks/Layout/TableCards/@types';
import {block}                                       from '../block';

const DATE_OPTIONS: Record<string, Intl.DateTimeFormatOptions> = {
    dateShort: {
        month:  'long',
        day:    'numeric',
    },
    date: {
        month:  'long',
        year:   'numeric',
        day:    'numeric',
    },
};

const isCurrentYear = (dateISO: string) =>
    new Date().getFullYear() === new Date(dateISO).getFullYear()
;

const getDateFormatted = (dateISO: string) =>
    formatDateWOptions(dateISO, ELocales.ru, DATE_OPTIONS[isCurrentYear(dateISO) ? 'dateShort' : 'date'])
;

const DataCell:FC<DataCellType> = ({row, column}) =>
    <div className={block.el('datacell-name') + block.el('datacell-nowrap')}>
        {
            row[column.name]
                ? `${getDateFormatted(row[column.name].dates.fromISO)} - ${getDateFormatted(row[column.name].dates.toISO)}`
                : ''
        }
    </div>
;

const ColumnCell:React.FC<ColumnCellType> = ({column}) =>
    <p className={block.el('columncell-name')}>
        {column.title}
    </p>
;

const FromToDateCell: UiSchemaEntry = {
    DataCell, ColumnCell
}

export {FromToDateCell};